module.exports = __webpack_public_path__ + "img/icon-web-2.dd18aff7.svg";